import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MailX, CheckCircle2 } from "lucide-react";
import { api, apiError } from "@/lib/api";

export default function NewsletterUnsubscribe() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState({ status: "error", message: "Lien invalide." }); return; }
    api.get("/newsletter/unsubscribe", { params: { token } })
      .then(({ data }) => setState({ status: "ok", email: data.email }))
      .catch((err) => setState({ status: "error", message: apiError(err.response?.data?.detail) }));
  }, [params]);

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-4 grain">
      <div className="relative z-10 max-w-md w-full glass rounded-3xl p-10 text-center" data-testid="unsubscribe-card">
        {state.status === "loading" && <p className="text-cream/60 font-mono2 text-sm">Un instant…</p>}
        {state.status === "ok" && (
          <>
            <CheckCircle2 className="w-16 h-16 text-mustard mx-auto" />
            <h1 className="font-display font-bold text-2xl mt-6">Désabonnement confirmé</h1>
            <p className="text-cream/60 mt-3 text-sm" data-testid="unsubscribe-success">
              <span className="text-cream">{state.email}</span> ne recevra plus la newsletter de l'AJDR Factory. À bientôt sur le dancefloor !
            </p>
          </>
        )}
        {state.status === "error" && (
          <>
            <MailX className="w-16 h-16 text-mustard mx-auto" />
            <h1 className="font-display font-bold text-2xl mt-6">Lien invalide</h1>
            <p className="text-cream/60 mt-3 text-sm" data-testid="unsubscribe-error">{state.message}</p>
          </>
        )}
        <button data-testid="unsubscribe-home-btn" onClick={() => navigate("/")} className="btn-mustard rounded-full px-6 py-3 mt-7">Retour au site</button>
      </div>
    </div>
  );
}
